import { callUnaryMethod } from '@connectrpc/connect-query'

import type {
  Customer,
  GetCustomerRequest,
} from '@jotta/grpc-connect-openapi/customer'
import { getCustomer } from '@jotta/grpc-connect-openapi/customerQuery'
import type { PartialMessage } from '@jotta/types/compat'

import { queryClient } from '../../../query/src/queryClient'
import { authTransport } from '../transport'

import { emptyCustomer } from './emptyCustomer'
import { getCustomerQueryKey } from './useGetCustomer'

export async function fetchCustomer(
  args: PartialMessage<GetCustomerRequest> = {},
): Promise<Customer> {
  const { customer = emptyCustomer } = await queryClient.fetchQuery({
    queryKey: getCustomerQueryKey,
    queryFn: () => callUnaryMethod(authTransport, getCustomer, args),
  })
  return customer
}
